var exports = {
  "q": "xfd349460--495d00--price",
  "R": "xfd349460--495d00--heading",
};

module.exports = exports;
